import React from 'react';
import StyledStepDescription from '../../../styles/StyledStepDescription';
import StyledStepLabel from '../../../styles/StyledStepLabel';
import StyledWorkflowStepLabel from './StyledWorkflowStepLabel';

interface WorkflowStepLabelProps {
  stepLabel?: string;
  label: string;
  description?: string;
}

const WorkflowStepLabel: React.FC<WorkflowStepLabelProps> = ({
  stepLabel,
  label,
  description,
}) => {
  return (
    <StyledWorkflowStepLabel>
      {stepLabel && <StyledStepLabel>{stepLabel}</StyledStepLabel>}
      <div>
        <h2>{label}</h2>
        {description && (
          <StyledStepDescription>{description}</StyledStepDescription>
        )}
      </div>
    </StyledWorkflowStepLabel>
  );
};

export default WorkflowStepLabel;
